import * as React from 'react';

function SvgCheckIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.857 8.68" {...props}>
      <path
        data-name="Path 2854"
        d="M10.679 1.295l-5.8 7.123a.7.7 0 01-.544.261.727.727 0 01-.457-.174L.257 5.34a.838.838 0 01-.109-1.088.674.674 0 01.924-.2h.065l3.11 2.741L9.598.268a.673.673 0 01.957-.13l.065.065a.827.827 0 01.059 1.092z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCheckIcon;
